/**
 * The Sentry `environment` for an event. Vercel says which deployment this is
 * (production | preview | development). Anything else falls back to the build
 * mode, so a laptop or a preview never reports as production.
 *
 * Load-bearing: the home-lab Sentry auto-fix only picks up issues whose
 * environment is `production`. The server instrument files can't import
 * TypeScript, so they inline this same rule.
 */
export function sentryEnvironment(
  vercelEnv: string | undefined,
  mode: string | undefined
): string {
  const vercel = vercelEnv?.trim();
  if (vercel) {
    return vercel;
  }
  return mode === "production" ? "production" : "development";
}
